import {Fonts} from '../../theme';

export default {
  inputDefault: {
    width: 300,
    height: 40,
    borderRadius: 4,
    fontSize: Fonts.size.text14,
  },
};
